import React, { useState } from "react";
import SignUpForm from "../components/core/SignUpForm";
import { app } from "../App";
import { emptyInvoiceData } from "../utils/emptyObjects";
import { FIREBASE_AUTH_ERROR_MESSAGES } from "../utils/dictionaries";
import { getAuth, signOut } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { normalizeFirstName, normalizeName } from "../utils/utils";
import { signUpFieldsList } from "../components/core/SignUp-SignIn/fieldsLists";
import { useNavigationHelper } from "../hooks/useNavigationHelper";
import { UserRole } from "../interfaces/enums";
import { validateUserForm } from "../utils/validations";

export default function SignUp() {
  const [formData, setFormData] = useState<Record<string, any>>(
    signUpFieldsList.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {}),
  );
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const [signUpError, setSignUpError] = useState<string | undefined>(undefined);
  const functions = getFunctions(app, "us-central1");
  const createUser = httpsCallable(functions, "createUser");
  const { goToThankYouPage } = useNavigationHelper();

  const validateFormData = () => {
    const validation = validateUserForm(formData);
    setFormErrors(validation.errors);
    return validation.isValid;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  };

  const handleSignUp = async () => {
    if (validateFormData()) {
      setLoading(true);
      setSignUpError(undefined);

      try {
        const newUserData = {
          consents: [],
          email: formData.email,
          firstName: normalizeFirstName(formData.firstName),
          invoiceData: emptyInvoiceData,
          isActive: true,
          isFirstLogin: true,
          isInvoiceNeeded: false,
          lastName: normalizeName(formData.lastName),
          organizationName: formData.organizationName,
          phoneNumber: formData.phoneNumber,
          roles: [UserRole.REGISTRANT],
          password: formData.password,
        };

        await createUser(newUserData);

        await signOut(getAuth(app));
        goToThankYouPage();
      } catch (error: any) {
        console.error("Błąd rejestracji:", error);
        const errorCode = error?.code?.replace("functions/", "auth/");
        setSignUpError(
          FIREBASE_AUTH_ERROR_MESSAGES[errorCode as keyof typeof FIREBASE_AUTH_ERROR_MESSAGES] ??
            "Wystąpił błąd podczas rejestracji. Spróbuj ponownie.",
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <SignUpForm
      formData={formData}
      formErrors={formErrors}
      onChange={handleChange}
      onClickSignUp={handleSignUp}
      loading={loading}
      error={signUpError}
    />
  );
}
